import { Alert, Flex, theme } from 'antd';
import { getDateString } from '@/utils/dateUtils/dateFormatUtils';
import { DATA_AVAILABILITY, type DataAvailabilityType } from './useIsBeforeDataAvailability';

interface DataAvailabilityBannerProps {
  dataType: DataAvailabilityType;
}

/**
 * Notice explaining that `dataType` data is only available from its cutoff date. Callers decide
 * when to show it with `useIsBeforeDataAvailability`.
 */
const DataAvailabilityBanner = ({ dataType }: DataAvailabilityBannerProps) => {
  const { token } = theme.useToken();
  const { label, availableFrom } = DATA_AVAILABILITY[dataType];

  return (
    <Flex vertical>
      <Alert
        type="info"
        showIcon
        data-testid={`data-availability-${dataType}-banner`}
        style={{ marginBottom: token.margin }}
        title={`${label} data is only available from ${getDateString(availableFrom)} onwards.`}
      />
    </Flex>
  );
};

export default DataAvailabilityBanner;
